import React, { useRef, useCallback } from "react";

import { Field, getIn } from "formik";

import { FormControl, FormLabel, FormErrorMessage } from "@chakra-ui/react";

import CustomSelect from "../CustomSelect";

export const CustomSelectWField = ({
  fieldName,
  label,
  placeholder,
  visible,
  getOptionLabel,
  getOptionValue,
  autoload,
  saude,
  isLoading,
  options,
  onChange,
  onFocus,
  mt,
  isDisabled,
  message,
  normal,
  limitado,
  searchable,
}) => {
  const formControlRef = useRef(null);

  const handleScrollToBottom = useCallback(() => {
    if (formControlRef.current) {
      formControlRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });

      if (limitado) {
        setTimeout(() => {
          formControlRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }, 300);
      }
    }
  }, [limitado]);

  const normalizeText = (text) =>
    text
      ?.toString()
      ?.normalize("NFD")
      ?.replace(/[\u0300-\u036f]/g, "")
      ?.replace(/[^a-zA-Z0-9\s]/g, "")
      ?.toLowerCase();

  return (
    <Field name={fieldName}>
      {({ field, form }) => (
        <FormControl
          name={fieldName}
          isInvalid={
            (form.errors[fieldName] && form.touched[fieldName]) ||
            (getIn(form.errors, fieldName) && getIn(form.touched, fieldName))
          }
          id={fieldName}
          mt={mt ? mt : "0px"}
          onClick={handleScrollToBottom}
          ref={formControlRef}
        >
          <FormLabel
            color="#5F6377"
            whiteSpace={"nowrap"}
            fontWeight="500"
            fontSize="14px"
            lineHeight="19.6px"
            htmlFor={fieldName}
          >
            {label}
          </FormLabel>

          {!saude || visible ? (
            <CustomSelect
              isInvalid={
                (form.errors[fieldName] && form.touched[fieldName]) ||
                (getIn(form.errors, fieldName) &&
                  getIn(form.touched, fieldName))
              }
              value={field.value || ""}
              placeholder={placeholder}
              getOptionLabel={getOptionLabel}
              getOptionValue={getOptionValue}
              autoload={autoload}
              isLoading={isLoading}
              options={options}
              onChange={onChange}
              onFocus={onFocus}
              isDisabled={isDisabled}
              message={message}
              normal={normal}
              limitado={limitado}
              searchable={searchable}
              filterOption={(option, inputValue) => {
                const input = normalizeText(inputValue || "");

                if (option?.data?.searchLabel) {
                  return normalizeText(option?.data?.searchLabel)?.includes(
                    input
                  );
                }

                const label =
                  option?.data?.nome ||
                  option?.data?.label ||
                  option?.label ||
                  "";
                return normalizeText(label)?.includes(input);
              }}
            />
          ) : (
            ""
          )}
          <FormErrorMessage>
            {form.errors[fieldName] ||
              getIn(form.errors, fieldName) ||
              getIn(form.errors, fieldName)}
          </FormErrorMessage>
        </FormControl>
      )}
    </Field>
  );
};
